import { Link } from "react-router-dom"
import Heading from "../../components/layout/Heading"
import StickySections from "../../components/layout/StickySections"
import ContactTransition from "../ContactTransition"
import ProjectFalling from "../ProjectFalling"
import clsx from "clsx"
import BlueEye from "../../components/assets/eyes/BlueEye"
import YellowEye from "../../components/assets/eyes/YellowEye"
import { useEffect, useState } from "react"
import axios from "axios"
import { BASE_URL } from "../../globals"
import Loader from "../../components/assets/Loader"
export default function Services() {
    const services = [
        {
            label: "Communication",
            slug: "communication",
            className: "bg-zoeil-blue"
        },
        {
            label: "Graphisme",
            slug: "graphisme",
            className: "bg-zoeil-pink"
        },
        {
            label: "Web Design",
            slug: "web-design",
            className: "bg-zoeil-light-blue"
        },
        {
            label: "Photo & Video",
            slug: "photo-video",
            className: "bg-zoeil-yellow"
        }
    ]

    const [sections, setSections] = useState([]);

    async function fetchSections() {
        try {
            const baseSections = [
                {
                    title: "Communication",
                    slug: "communication",
                    skills: ["Community Management", "Publicité", "Print", "Statégie"],
                    catch_phrase: "Crier haut et fort pour te mettre en lumière",
                    text: "On voit loin pour ta com' ! Des stratégies qui tapent dans l’œil et qui te mettent direct dans le champ de vision de ton public. On te fait passer au clair, net et précis.",
                    buttons: [
                        {
                            "label": "Demander un Call",
                            "href": "/contact"
                        },
                        {
                            "label": "Voir les Réalisations",
                            "href": "/services/communication"
                        }
                    ],
                },
                {
                    title: "Graphisme",
                    slug: "graphisme",
                    skills: ["Identité Visuelle", "Design", "Charte graphique", "Campagne publicitaire"],
                    catch_phrase: "Du dessin, mais pas que sur papier",
                    text: "Le graphisme, c'est notre super-pouvoir ! On te crée des visuels qui vont flasher ! On met de la couleur dans ta vie pour que ça pète aux yeux de tout le monde !",
                    buttons: [
                        {
                            "label": "Demander un Call",
                            "href": "/contact"
                        },
                        {
                            "label": "Voir les Réalisations",
                            "href": "/services/graphisme"
                        }
                    ],
                },
                {
                    title: "Web Design",
                    slug: "web-design",
                    skills: ["Site Web", "Application", "Design system", "Web app"],
                    catch_phrase: "J’ai juste à reprendre un template",
                    text: "On te tisse une toile qui déchire ! Des sites web qui font tourner les têtes et cliquer les souris. On te crée un espace digital qui va faire vibrer ta marque sur tous les écrans !",
                    buttons: [
                        {
                            "label": "Demander un Call",
                            "href": "/contact"
                        },
                        {
                            "label": "Voir les Réalisations",
                            "href": "/services/web-design"
                        }
                    ],
                },
                {
                    title: "Photo & Video",
                    slug: "photo-video",
                    skills: ["Courts métrages", "Reels", "Photos souvenirs", "Documentaires"],
                    catch_phrase: "Presser la gâchette pour tuer le temps.",
                    text: "On capture le vrai, le beau, le fou ! Des photos et vidéos qui en mettent plein la vue, histoire que tes projets sortent de l’ombre et captivent tous les regards.",
                    buttons: [
                        {
                            "label": "Demander un Call",
                            "href": "/contact"
                        },
                        {
                            "label": "Voir les Réalisations",
                            "href": "/services/photo-video"
                        }
                    ],
                }
            ];
            const taxonomy = "service";
            for (let section of baseSections) {
                const termData = await axios.get(`${BASE_URL}/${taxonomy}?slug=${section.slug}`);
                if (termData.data.length > 0) {
                    const termId = termData.data[0].id;
                    const post_type = "realisation";
                    const termPosts = await axios.get(`${BASE_URL}/${post_type}?${taxonomy}=${termId}&per_page=5&orderby=rand`);
                    const images = [];
                    for (let termPost of termPosts.data) {
                        const mediaData = await axios.get(`${BASE_URL}/media/${termPost.featured_media}`);
                        images.push(
                            {
                                post_slug: termPost.slug,
                                src: mediaData.data.source_url,
                                alt: mediaData.data.alt_text
                            }
                        )
                    }
                    section.images = images;
                }
            }
            setSections(baseSections);
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        fetchSections();
    }, []);

    return (
        <>
            <div className="min-h-[500px] flex flex-col justify-center items-center px-8 mobile:py-32">
                <div className="w-fit tablet:w-full mx-auto relative">
                    <div className="w-full relative mobile:static">
                        <Heading
                            title="Découvre nos Services"
                            highlighted_words={["Services"]}
                            subtitle="Si tu ne trouves pas ce qu’il te faut, on comprend pas. Après on ne vend pas non plus des voitures ..."
                        />
                        <div className="w-[6.25rem] mobile:w-[3rem] absolute right-0 top-0 -rotate-[160deg] mobile:top-1/2 mobile:-translate-y-1/2">
                            <BlueEye version={2} />
                        </div>
                        <div className="w-[6.25rem] mobile:w-[3rem] absolute left-0 bottom-0 -rotate-[12deg]">
                            <YellowEye />
                        </div>
                    </div>
                    <ul className="flex justify-center items-center gap-[2.25rem] flex-wrap mobile:flex-col mobile:w-fit mobile:mx-auto">
                        {services.map(service =>
                            <li className="text-heading-4 uppercase text-white mobile:w-full text-center">
                                <Link to={`/services/${service.slug}`}>
                                    <div className={clsx(
                                        service.className,
                                        "px-[10px] py-[3px]"
                                    )}>
                                        {service.label}
                                    </div>
                                </Link>
                            </li>
                        )}
                    </ul>
                </div>
            </div>
            {sections.length > 0 ? <StickySections
                sections={
                    sections
                } />
                : <div className="flex justify-center items-center">
                    <Loader />
                </div>}
            <ProjectFalling />
        </>
    )
}